import { render, staticRenderFns } from "./orderHandleDetail.vue?vue&type=template&id=33086168&scoped=true&"
import script from "./orderHandleDetail.vue?vue&type=script&lang=ts&"
export * from "./orderHandleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./orderHandleDetail.vue?vue&type=style&index=0&id=33086168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33086168",
  null
  
)

export default component.exports